// extracted by mini-css-extract-plugin
export default {"tablecontainer":"Pricing_tablecontainer__JFs6X"};